import { render } from "./slicing.vue?vue&type=template&id=1297edf4&ts=true"
import script from "./slicing.vue?vue&type=script&lang=ts"
export * from "./slicing.vue?vue&type=script&lang=ts"

import "./slicing.vue?vue&type=style&index=0&id=1297edf4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__